import { Client, User } from 'types';
import log from 'shared/utils/log';
import { getVisitorDisplayName } from './visitor';

export function formatUserForPost(user: User) {
  return {
    ...user,
    avatar: user.avatar ? user.avatar.imageUrl : null,
  };
}

export function generateSlugUrl(id: number, title: string) {
  const slug = title
    .toLowerCase()
    .replace(/[\s_]+/g, '-')
    .replace(/[’'"]+/g, '')
    .replace(/[^\w-]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-*|-*$/g, '');
  return `${id}-${slug}`;
}

export function extractIdFromSlug(slug: string) {
  const id = parseInt(slug, 10);
  if (isNaN(id)) {
    // tslint:disable:no-console
    log.error('extractIdFromSlug could not find id in : ' + slug);
  }
  return id;
}

export const clientToFe = (c: Client) => {
  c.sbid = c.sbid || (c as any).id;
  c.displayName = getVisitorDisplayName(c) || 'Unknown';
  return c;
};
